export default "__VITE_ASSET__BNCl5Se9__"